export const calcConsultantHours = (workingDay) => {
	return workingDay.attendance_at_work || 0;
};
